import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

import { usePlayground } from "../playground-store";
import { PLAYGROUND_SESSION_MODES } from "../types";

/**
 * Applies a one-shot `?mode=chat` URL param (e.g. from the What's New CTA) once the
 * session has initialized, then removes the param so refreshes keep the user's choice.
 */
const usePlaygroundModeFromUrl = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { sessionMode, setSessionMode, isPendingSessionInitialization, isInitializing } =
    usePlayground();

  const hasApplied = useRef(false);

  useEffect(() => {
    if (hasApplied.current || isPendingSessionInitialization || isInitializing) {
      return;
    }

    if (searchParams.get("mode") !== PLAYGROUND_SESSION_MODES.CHAT) {
      hasApplied.current = true;
      return;
    }

    hasApplied.current = true;
    if (sessionMode !== PLAYGROUND_SESSION_MODES.CHAT) {
      setSessionMode(PLAYGROUND_SESSION_MODES.CHAT);
    }
    searchParams.delete("mode");
    setSearchParams(searchParams, { replace: true });
  }, [
    isPendingSessionInitialization,
    isInitializing,
    searchParams,
    setSearchParams,
    sessionMode,
    setSessionMode,
  ]);
};

export default usePlaygroundModeFromUrl;
